import React from "react";
import { CompanyList, FeatureList, PackageInfoForm, ProjectList } from ".";

const PANELS = {
	features: {
		title: "dsi.package-management.panel.features.title",
		panel: ({ onUpdateRow, pck }) => <FeatureList id={pck?.id} onUpdateRow={onUpdateRow} />,
	},
	companies: {
		title: "dsi.package-management.panel.companies.title",
		panel: ({ onUpdateRow, pck, platformCompanies }) => (
			<CompanyList id={pck?.id} platformCompanies={platformCompanies} onUpdateRow={onUpdateRow} />
		),
	},
	projects: {
		title: "dsi.package-management.panel.projects.title",
		panel: ({ projectsRequest }) => <ProjectList projectsRequest={projectsRequest} />,
	},
	info: {
		title: "dsi.package-management.panel.info.title",
		panel: ({ pck, onClose, onUpdateRow }) => (
			<PackageInfoForm pck={pck} onClose={onClose} onUpdateRow={onUpdateRow} />
		),
	},
	creation: {
		title: "dsi.package-management.panel.creation.title",
		panel: ({ onClose, onRefreshList }) => <PackageInfoForm onClose={onClose} onRefreshList={onRefreshList} />,
	},
};

export default PANELS;
